module.exports = __webpack_public_path__ + "images/e6ad4820953d7881d8ac86a5db49c827.active.svg";